import '../layouts/ansysoft.css';
import rightarrow from '../assets/right-arrow.svg';
import missiontext from '../assets/missiontext.webp';
import missionimage from '../assets/missionimage.webp';
import { Link } from 'react-router-dom';
import Footer from '../components/footer';

function AboutUs() {
    return (
        <>
            <div className="w-100 banner-bg">
                <div className="banner-bg-1">
                    <div className="container banner-wrap-aboutus">
                        <div className="banner">
                            <h1 className="subheading-1-aboutus">WE CONNECT PEOPLE</h1>
                            <h1 className="heading-1-aboutus">From all over the World</h1>
                            <p className="description-1-aboutus mt-3 mt-md-5">WebBull serves as a powerful platform that connects individuals from across the globe, fostering a sense of unity and collaboration.</p>
                            <Link to="/signin" className="btn-main scnd-width  btn-outline-main margin-l">
                                JOIN NOW
                                <img src={rightarrow} className='arrow' alt="===>" width="36" height="100%" />
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
            <div className="w-100 possibilities-bg">
                <div className="possibilities-bg-1">
                    <div className="container possibilities">
                        <p className="para-2-aboutus">WebBull decentralized networking platform based on smart contracts, together with USDT, which brings people together from all over the world and opens up endless possibilities on economic financial systems.</p>
                    </div>
                </div>
            </div>
            <div className="w-100 mission-bg">
                <div className="container mission-wrap pt-0">
                    {/* <img src={missiontext} alt="MISSION OF WEBBULL" /> */}
                    <div className="mission pe-3">
                        <div className="mission-image-wrap">
                            <img src={missionimage} className="mission-image" />
                        </div>
                        <div className="mission-text">
                            <h3 className="mission-text-heading mt-3">Unlock Your Wealth Creation Potential: Attain the Luxurious Life You Desire.</h3>
                            <ol className="mission-text-list mt-4">
                                <li className="mission-point">
                                    <div className="point-number" style={{marginRight: '16px'}}>1.</div>
                                    <div className="point-text">Cultivating Global Legends: Empowering Millions with Education and Knowledge. </div>
                                </li>
                                <li className="mission-point">
                                    <div className="point-number">2.</div>
                                    <div className="point-text">Transforming Dreams into Reality: Making Your Aspirations Achievable.</div>
                                </li>
                                <li className="mission-point">
                                    <div className="point-number">3.</div>
                                    <div className="point-text">Enriching Minds, Enriching Families: Building Wealthy Mindsets Across the Globe.</div>
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>

            <div className="w-100 vision-bg-aboutus">
                <div className="container vision-aboutus">
                    <h3 className="heading-4-aboutus">OUR VISION</h3>
                    <p className="para-4-aboutus">Empowering individuals for everyday earning potential with a simple and inclusive system. With the exponential growth of blockchain technology and stable coin markets, we are dedicated to providing a genuine platform that unlocks opportunities for ambitious individuals.</p>
                </div>
            </div>
            <Footer/>
        </>
    )
}

export default AboutUs;